'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function styles(invalid) {
  return {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: invalid ? 'pink' : 'white'
  };
}

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.InputNumber',

  propTypes: {
    value: _react.PropTypes.number.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      strValue: String(this.props.value),
      invalid: false
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        strValue: String(nextProps.value),
        invalid: false
      });
    }
  },

  handleChange: function handleChange(event) {
    var strValue = event.target.value;
    var value = Number(strValue);
    var invalid = Number.isNaN(value);
    this.setState({ strValue: strValue, invalid: invalid });
    if (!invalid) {
      this.props.onChange(value);
    }
  },

  render: function render() {
    var _state = this.state;
    var strValue = _state.strValue;
    var invalid = _state.invalid;

    return _react2['default'].createElement('input', {
      type: 'text',
      style: styles(invalid),
      value: strValue,
      onChange: this.handleChange
    });
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/InputNumber.js
// module id = 965
// module chunks = 0